/* eslint-disable max-len, no-await-in-loop, no-new, no-unused-vars, padded-blocks */
/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import api from '@/api';

export const namespaced = true;

export const state = {
  organizationBriefs: [],
  serverError: null,
};

export const actions = {
  async getOrganizationBriefs({ commit }) {
    await api.get('/organization/briefs').then(async (response) => {
      commit('SET_ORGANIZATION_BRIEFS', response.data);
    }).catch((exception) => {
      console.error(exception);
      commit('SET_ORGANIZATION_BRIEFS', []);
      commit('SET_SERVER_ERROR', exception);
    });
  },
};

export const mutations = {
  SET_ORGANIZATION_BRIEFS(state, data) {
    state.organizationBriefs = data;
  },
  SET_SERVER_ERROR(state, exception) {
    state.serverError = exception;
  },
};
